<template>
  <div class="big">
    <div class="page_title">名医妙谈列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <el-button
            type="primary"
            @click="addEssay"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('660') : false
            "
            >添加文章
          </el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="标题" prop="title"> </el-table-column>
            <el-table-column label="作者" prop="author"> </el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.pic_url"
                  alt
                  style="width: 160px; height: 90px"
                />
              </template>
            </el-table-column>
            <el-table-column label="编辑时间" prop="update_time">
            </el-table-column>
            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-button
                  @click="updateSort(scope.$index, 1)"
                  v-if="scope.$index != 0"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('659')
                      : false
                  "
                  >置顶</el-button
                >

                <el-button
                  @click="updateSort(scope.$index, 2)"
                  v-if="scope.$index != 0"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('659')
                      : false
                  "
                  >上移</el-button
                >

                <el-button
                  @click="updateSort(scope.$index, 3)"
                  v-if="scope.$index != tableData.length - 1"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('659')
                      : false
                  "
                  >下移</el-button
                >
                <el-button
                  @click="updateSort(scope.$index, 4)"
                  v-if="scope.$index != tableData.length - 1"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('659')
                      : false
                  "
                  >置底</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待发布</span>
                <span v-if="scope.row.status == 2">已发布</span>
                <span v-if="scope.row.status == 3">已下架</span>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="toDetail(scope.row.info_id, scope.row.type)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('661')
                      : false
                  "
                  >详情</el-button
                >
                <el-button
                  @click="updateStatus(scope.row.info_id, 2)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status !== 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('662')
                      : false
                  "
                  >发布</el-button
                >
                <el-button
                  @click="updateStatus(scope.row.info_id, 3)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status == 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('662')
                      : false
                  "
                  >下架</el-button
                >
                <el-button
                  @click="delEssay(scope.row.info_id)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status !== 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('663')
                      : false
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      type: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      this.axios
        .post('platform/library/getFamousDoctorTalkList')
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = item.update_time
                ? dayjs.unix(item.update_time).format('YYYY-MM-DD HH:mm:ss')
                : '';
              return item;
            });
          }
        });
    },
    //添加
    addEssay() {
      this.$router.push('famousdoctoressay');
    },
    //删除
    delEssay(info_id) {
      this.$confirm('您确定删除该文章吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/library/deleteFamousDoctorTalkInfo', { info_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //发布 下架
    updateStatus(info_id, status) {
      let msg = '您确定要发布该文章吗？';
      if (status == 3) {
        msg = '该文章当前已发布，确定要下架吗？';
      }
      this.$confirm(msg, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/library/changeFamousDoctorTalkStatus', {
              info_id,
              status
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //详情
    toDetail(info_id) {
      this.$router.push({ path: 'famousdoctoressay', query: { info_id } });
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //上移
      if (status == 2) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 3) {
        this.tableData.splice(index + 1, 0, data);
      }
      //置底
      if (status == 4) {
        this.tableData.push(data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ['info_id', 'sort']);
        return item;
      });
      this.axios
        .post('platform/library/editFamousDoctorTalkSort', { list })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功');
            this.getList();
          }
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
}
.add文章 {
  padding: 0 0 30px 30px;
  box-sizing: border-box;
  text-align: left;
  border-bottom: solid 2px #e7e7e7;
}
</style>

